// SuplantacionBanner.js — Barra fija mientras un admin está «dentro como» un
// usuario: a quién ve, si lo que hace se guarda, cuánto le queda y Salir.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';
import { suplantacionService } from '../services/api';
import { tomarRespaldoSesion } from '../utils/suplantacion';

const ALTO = 48;

const Barra = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000;
  min-height: ${ALTO}px;
  padding: 0.5rem 1rem calc(0.5rem + env(safe-area-inset-bottom, 0px));
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem 1rem;
  flex-wrap: wrap;
  background: ${p => (p.$guarda ? '#9a3412' : '#0f355b')};
  color: #fff;
  font: 500 0.88rem/1.35 'Segoe UI', system-ui, sans-serif;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
`;

const Modo = styled.span`
  padding: 2px 8px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.18);
  font-size: 0.78rem;
  font-weight: 700;
  white-space: nowrap;
`;

const Salir = styled.button`
  border: none;
  border-radius: 6px;
  padding: 0.35rem 1rem;
  background: #fff;
  color: #0f355b;
  font: 700 0.85rem 'Segoe UI', system-ui, sans-serif;
  cursor: pointer;
  &:hover { background: #e2e8f0; }
`;

const minutosRestantes = (expira) => Math.max(0, Math.ceil((expira * 1000 - Date.now()) / 60000));

const SuplantacionBanner = () => {
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();
  const sup = user?.suplantacion;
  const [minutos, setMinutos] = useState(() => (sup ? minutosRestantes(sup.expira) : 0));

  useEffect(() => {
    if (!sup) return undefined;
    setMinutos(minutosRestantes(sup.expira));
    const t = setInterval(() => setMinutos(minutosRestantes(sup.expira)), 30000);
    // Que la barra no tape el final de la página.
    const previo = document.body.style.paddingBottom;
    document.body.style.paddingBottom = `${ALTO + 8}px`;
    return () => {
      clearInterval(t);
      document.body.style.paddingBottom = previo;
    };
  }, [sup]);

  if (!sup) return null;

  const salir = async () => {
    try { await suplantacionService.salir(); } catch (e) { /* la sesión vence sola */ }
    const previa = tomarRespaldoSesion();
    if (previa) login(previa); else logout();
    // La pestaña la abrió el admin con window.open: se puede cerrar. Si no, al inicio.
    window.close();
    navigate('/', { replace: true });
  };

  return (
    <Barra $guarda={!!sup.guardar_avance} role="status">
      <span>
        👁 Estás dentro como <strong>{user.nombre}</strong> ({user.email})
      </span>
      <Modo title={sup.guardar_avance
        ? 'Lo que hagas (lecciones, exámenes, certificados) queda en el historial del usuario'
        : 'Puedes usar todo normalmente, pero nada de lo que hagas se guarda'}
      >
        {sup.guardar_avance ? 'GUARDANDO AVANCE' : 'SOLO MIRAR'}
      </Modo>
      <span style={{ opacity: 0.8, fontSize: '0.8rem' }}>vence en {minutos} min</span>
      <Salir onClick={salir}>Salir</Salir>
    </Barra>
  );
};

export default SuplantacionBanner;
